// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.message-detail {
  width: 100%;
  border: 1px solid #c2bfbe !important;
  margin-bottom: 20px;
}
.message-details-info {
  width: 100%;
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
}
.message-details-info-header {
  font-weight: 500;
}

.back-btn {
  display: flex;
  align-items: center;
}
.back-btn:hover {
  display: flex;
  align-items: center;
  border-color: #009966 !important;
  color: #009966 !important;
}
.message-item-meta-data {
  flex: none !important;
}
.payapt-list-item {
  display: flex;
  justify-content: space-between;
  width: 100%;
}
.ant-table-thead {
  background-color: #e1dfde !important;
}
.test-data-container {
  /* height: auto; */
  /* border: 1px solid #F5F5F5; */
  display: flex;
  flex-direction: row;
}
/* messages-container. { */
  /* align-items: center; */
  /* justify-content: center; */
  /* display: flex; */
  /* height: 100%; */
/* } */
.test-case-menu-item {
  font-family: "Inter";
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 17px;
  text-transform: capitalize;
  color: var(--black-text);
  margin-bottom: 12px;
  padding-left: 24px;
  height: 40px;
  align-items: center;
  width: auto;
  align-items: center;
  display: flex;
  border-left: 4px solid var(--background-white);
}
.test-case-menu-item-active {
  font-family: "Inter";
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 17px;
  text-transform: capitalize;
  color: var(--black-text);
  margin-bottom: 12px;
  padding-left: 24px;
  height: 40px;
  width: auto;
  align-items: center;
  border-left: 4px solid var(--primary-color);
  display: flex;
  background-color: var(--menu-item-background);
}
.test-data-sidemenu {
  width: 291px;
  height: 400px;
  border: 1px solid #f5f5f5;
}
.search-box {
  /* width: 292px; */
  height: 40px;
  background: var(--background-white);
  border: 1px solid var(--disabled-text-color);
  border-radius: 0;
  font-weight: 300;
  font-size: 16px;
  font-family: "Inter";
  font-style: normal;
}
.search-icon {
  color: var(--disabled-text-color);
}
.test-data-values-container {
  /* width: 840px; */
  /* width: auto !important; */
  max-height: 60vh;
  background: var(--background-white);
  border: 1px solid #f5f5f5;
  /* padding-top: 25px; */
  /* padding-left: 9px; */
  /* padding-bottom: 25px; */
  /* padding-right: 13px; */
  margin-right: 0px !important;
}
.test-data-value-row {
  display: flex;
  justify-content: space-between;
  /* margin-bottom: 20px; */
}
.test-data-xpath-value {
  width: 330px;
  height: 30px;
  background: var(--background-white);
  border: 1px solid #c6cbd1;
  border-radius: 5px;
  margin-top: 5px;
  margin-bottom: 5px;
}
.test-data-xpath {
  display: flex;
  flex-direction: column;
}
.xpath-label {
  font-family: "Inter";
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 19px;

  color: var(--text-color);
  margin-bottom: 6px;
}

.test-data-footer-buttons {
  /* margin-left: 5px !important; */
  margin-top: 30px !important;
  /* margin-bottom: 19px !important; */
  padding-left: 14px;
  display: flex;
  gap: 5px;
}
.xpath-value-table-header {
  /* width: 817px; */
  height: 40px;
  background: #f2f2f2;
  border-radius: 5px 5px 0px 0px;
}
.table-col-header {
  align-items: center;
  font-family: "Inter";
  font-style: normal;
  font-weight: 600;
  font-size: 18px;
  line-height: 22px;
  text-transform: capitalize;
  color: var(--text-color);
  padding-left: 14px;
  display: flex;
}
.table-col-header1 {
  align-items: center;
  font-family: "Inter";
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 22px;
  text-transform: capitalize;
  color: var(--text-color);
  padding-left: 14px;
  display: flex;
}
.testcases-menu {
  /* height: 460px; */
  overflow: auto;
  max-height: 55vh;
  /* overflow-y: auto; */
  display: grid;
  position: relative;
}
.xpath-value-content {
  overflow: auto;
  padding: 10px;
  display: grid;
  position: relative;
}
.review-txt-header {
  font-family: "Inter";
  font-style: normal;
  font-weight: 600;
  font-size: 20px;
  line-height: 24px;
  text-transform: capitalize;
  height: 24px;
  color: #001a11;
}
.review-txt-content{
height: 17px;
left: 124px;
top: 173px;

font-family: 'Inter';
font-style: italic;
font-weight: 400;
font-size: 14px;
line-height: 17px;
/* identical to box height */
color: #000000;
}
.xml-txt-label {
  width: 75px;
  height: 14.96px;
  left: 123px;
  top: 262px;
  margin-bottom: 10px;

  font-family: "Inter";
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 19px;
  color: #001a11;
}
.xml-txt-area {
  /* width: 90%;
  height: 298px;
  left: 123px;
  top: 291px; */
  background: #ffffff;
  border: 1px solid #c6cbd1;
  border-radius: 5px;
  resize: none;
  justify-content: flex-start;
  display: flex;
  width: 100%;
  /* margin-bottom: 10px; */
}
.standalone-message-testcase-container {
  display: flex;
  flex-direction: row;
  position: relative;
  /* margin-left: 35px; */
  /* margin-top: 22px; */
  /* margin-right: 30px; */
}

.testcase-detail-container {
  height: calc(90vh - 50px) !important;
  overflow-y: auto;
  background: #FFFFFF;
  border-left: 1px solid #D4D4D4;
}
.testcase-detail-header {
  height: 90px;
  background: #F5F5F5;
  border-left: 1px solid #D4D4D4;
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding-left: 14px;
  padding-right: 22px;
  z-index: 100;
}

.Validation-detail-container {
  height: 100vh !important;
  overflow-y: auto;
  background: #FFFFFF;
  border-left: 1px solid #D4D4D4;
}

.Validation-detail-header {
  background: #F5F5F5;
  border-left: 1px solid #D4D4D4;
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding-right: 22px;
  z-index: 100;
}
.Validation{
  display: flex;
}

.schemaValidationHeader{
 text-align: left;
 padding-left: 10px;
 padding-top: 15px;
 padding-bottom: 10px;
 font-size: 20px;
 font-weight: bold;
}

.schemaValidationSucces{
  background-color: rgb(221, 248, 238);
  text-align: left;
  border-left: 6px solid green;
  padding: 14px;
 }
 .schemaValidationError{
  background-color: rgb(251, 237, 237);
  text-align: left;
  border-left: 6px solid rgb(221, 59, 59);
  padding: 14px;
 }

.testcase-detail-header > .header1 {
  margin-left: 0 !important;
  margin-top: 0;
  margin-bottom: 6px;
}
.subtitle-buttons-container > .header2-italic {
  margin: 0 !important;
}
.testcase-name {
  font-family: 'Inter';
  font-style: italic;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: var(--primary-color);
}
.testcase-details-row {
  display: flex;
  flex-direction: row;
  margin-top: 15px;
  margin-bottom: 15px;
}
.testcase-detail-item {
  display: flex;
  flex-direction: column;
  width: 50%;
}
.testcase-detail-item-header {
  font-family: 'Inter';
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 22px;
  text-transform: capitalize;
  color: var(--text-color);
  text-align: left;
  margin-bottom: 9px;
}
.testcase-detail-item-value {
  font-family: 'Inter';
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 19px;
  color: var(--black-text);
  text-align: left;
}
.desc-title {
  font-family: 'Inter';
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  line-height: 22px;
  text-transform: capitalize;
  color: var(--text-color);
  text-align: left;
  display: flex;
  margin-top: 14px;
  margin-bottom: 9px
}

.desc-content {
  font-family: 'Inter';
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 19px;
  color: var(--black-text);
  opacity: 0.8;
  display: flex;
  text-align: left;
}
.desc-subtitle {
  margin-top: 20px;
}
.item-index-container {
  display: flex;
  flex-direction: row;
}
.panel-header {
  font-family: 'Inter';
  font-style: normal;
  font-weight: 600;
  font-size: 18px;
  line-height: 22px;
  text-transform: capitalize;
  color: var(--text-color);
  text-align: left;
  background: #F2F2F2;

  /* height: 48px; */
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.panel-content-container {
  background-color: var(--background-white);
  min-height: 30vh !important;
  overflow-y: auto;
}
.panel-content {
  padding-left: 14px;
  padding-top: 20px;
}
.ant-collapse-content-box {
  padding: 0 !important;
}
.subtitle-buttons-container {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
}
.prev-next-buttons {
  display: flex;
  justify-content: space-between;
  color: var(--text-color);
}
.testcase-details-container {
  padding-left: 14px;
  padding-right: 10px;
  width: 100%;
  overflow: auto;
  height: '100%';
  /* height: 80vh; */
  /* position: sticky; */
}
body {
  overflow: auto;
}
.close-circle {
  top: 8px;
  right: 11px;
  align-self: flex-end;
  display: flex;
}
.nested_table > div> div>.ant-table {
  margin-left: 0 !important;
}
.ant-table-expanded-row > .ant-table-cell {
  padding-left: 0 !important;
}
.data-loader {
  justify-self: center !important;
  align-self: center !important;
  display: flex !important;
  color: var(--primary-color) !important;
  width: 20px !important;
  height: 20px !important;
  position: absolute;
}

.cardTitle1{
  background-color: rgb(209, 244, 250);
  padding: 20px;
  font-size: 20px;
 }

 .cardTitle2{
  font-size: 20px;
 }

 .editor {
  counter-reset: line;
  border: 1px solid #daced1;
  /* background-color: yellow; */
}
.source {
  padding-left: 0px !important;
  margin-right: 5px !important;
  cursor:auto; 
}

#text-area-with-line-number::-webkit-scrollbar {
  width: 4px;
  border-radius: 40px;
  height: 4px;
  cursor: pointer !important;
}

#text-area-with-line-number::-webkit-scrollbar-track {
  background-color: #f2f2f2;
  border-radius: 40px;
}

#text-area-with-line-number::-webkit-scrollbar-thumb {
  border-radius: 10px;
}

.editor #codeArea {
  outline: none;
  padding-left: 60px !important;
}

.editor pre {
  padding-left: 60px !important;
}

.editor .editorLineNumber {
  position: absolute;
  left: 0px;
  color: #cccccc;
  text-align: right;
  width: 40px;
  font-weight: 100;
}

.actionGroup{
  display:flex;
  flex-direction: row;
}
.iconGroup{
  margin:0px 5px;
  border:1px solid #C6CBD1;
  border-radius:50%;
}

.span{
  padding:5px 5px;
}

.cancelicon{
  color: #D65442;
  height: 10px;
  width: 10px;
}

.checkicon{
  color: #549E56;
  height: 10px;
  width: 10px;
}

.headerAction:hover{
  cursor: pointer;
}
@media screen and ( min-height: 701px ) {
  .content-save-btn {
    height: 45vh !important;
  }
  .content-no-save-btn {
    height: 45vh !important;
  }
}

@media screen and ( max-height: 700px ) {
  .content-save-btn {
    height: 45vh !important;
  }
  .content-no-save-btn {
    height: 45vh !important;
  }
}

@media screen and ( max-height: 400px ) {
  .content-save-btn {
    height: 35vh !important;
  }
  .content-no-save-btn {
    height: 35vh !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/styles/message.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,oCAAoC;EACpC,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,gCAAgC;EAChC,yBAAyB;AAC3B;AACA;EACE,qBAAqB;AACvB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,WAAW;AACb;AACA;EACE,oCAAoC;AACtC;AACA;EACE,kBAAkB;EAClB,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;AACrB;AACA,0BAA0B;EACxB,yBAAyB;EACzB,6BAA6B;EAC7B,mBAAmB;EACnB,kBAAkB;AACpB,MAAM;AACN;EACE,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,0BAA0B;EAC1B,wBAAwB;EACxB,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,WAAW;EACX,mBAAmB;EACnB,aAAa;EACb,8CAA8C;AAChD;AACA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,0BAA0B;EAC1B,wBAAwB;EACxB,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,2CAA2C;EAC3C,aAAa;EACb,6CAA6C;AAC/C;AACA;EACE,YAAY;EACZ,aAAa;EACb,yBAAyB;AAC3B;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,mCAAmC;EACnC,4CAA4C;EAC5C,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,kBAAkB;AACpB;AACA;EACE,iCAAiC;AACnC;AACA;EACE,kBAAkB;EAClB,4BAA4B;EAC5B,gBAAgB;EAChB,mCAAmC;EACnC,yBAAyB;EACzB,uBAAuB;EACvB,uBAAuB;EACvB,0BAA0B;EAC1B,yBAAyB;EACzB,4BAA4B;AAC9B;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,yBAAyB;AAC3B;AACA;EACE,YAAY;EACZ,YAAY;EACZ,mCAAmC;EACnC,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;;EAEjB,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,iCAAiC;EACjC,2BAA2B;EAC3B,oCAAoC;EACpC,kBAAkB;EAClB,aAAa;EACb,QAAQ;AACV;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,8BAA8B;AAChC;AACA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,0BAA0B;EAC1B,wBAAwB;EACxB,kBAAkB;EAClB,aAAa;AACf;AACA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,0BAA0B;EAC1B,wBAAwB;EACxB,kBAAkB;EAClB,aAAa;AACf;AACA;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,sBAAsB;EACtB,aAAa;EACb,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,aAAa;EACb,aAAa;EACb,kBAAkB;AACpB;AACA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,0BAA0B;EAC1B,YAAY;EACZ,cAAc;AAChB;AACA;AACA,YAAY;AACZ,WAAW;AACX,UAAU;;AAEV,oBAAoB;AACpB,kBAAkB;AAClB,gBAAgB;AAChB,eAAe;AACf,iBAAiB;AACjB,4BAA4B;AAC5B,cAAc;AACd;AACA;EACE,WAAW;EACX,eAAe;EACf,WAAW;EACX,UAAU;EACV,mBAAmB;;EAEnB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE;;;eAGa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,2BAA2B;EAC3B,aAAa;EACb,WAAW;EACX,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,uBAAuB;EACvB,sBAAsB;EACtB,wBAAwB;AAC1B;;AAEA;EACE,oCAAoC;EACpC,gBAAgB;EAChB,mBAAmB;EACnB,8BAA8B;AAChC;AACA;EACE,YAAY;EACZ,mBAAmB;EACnB,8BAA8B;EAC9B,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;EAChB,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;EACnB,8BAA8B;EAC9B,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,aAAa;AACf;;AAEA;CACC,gBAAgB;CAChB,kBAAkB;CAClB,iBAAiB;CACjB,oBAAoB;CACpB,eAAe;CACf,iBAAiB;AAClB;;AAEA;EACE,oCAAoC;EACpC,gBAAgB;EAChB,4BAA4B;EAC5B,aAAa;CACd;CACA;EACC,oCAAoC;EACpC,gBAAgB;EAChB,uCAAuC;EACvC,aAAa;CACd;;AAED;EACE,yBAAyB;EACzB,aAAa;EACb,kBAAkB;AACpB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,2BAA2B;AAC7B;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,UAAU;AACZ;AACA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,0BAA0B;EAC1B,wBAAwB;EACxB,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,wBAAwB;EACxB,gBAAgB;AAClB;AACA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,0BAA0B;EAC1B,wBAAwB;EACxB,gBAAgB;EAChB,aAAa;EACb,gBAAgB;EAChB;AACF;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,wBAAwB;EACxB,YAAY;EACZ,aAAa;EACb,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,0BAA0B;EAC1B,wBAAwB;EACxB,gBAAgB;EAChB,mBAAmB;;EAEnB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,8BAA8B;AAChC;AACA;EACE,yCAAyC;EACzC,2BAA2B;EAC3B,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;AACb;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,wBAAwB;AAC1B;AACA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,cAAc;EACd,cAAc;EACd,kBAAkB;EAClB,sBAAsB;AACxB;AACA;EACE,cAAc;AAChB;AACA;EACE,QAAQ;EACR,WAAW;EACX,oBAAoB;EACpB,aAAa;AACf;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,+BAA+B;EAC/B,6BAA6B;EAC7B,wBAAwB;EACxB,sCAAsC;EACtC,sBAAsB;EACtB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;EACpC,aAAa;EACb,eAAe;CAChB;;CAEA;EACC,eAAe;CAChB;;CAEA;EACC,mBAAmB;EACnB,yBAAyB;EACzB,8BAA8B;AAChC;AACA;EACE,4BAA4B;EAC5B,4BAA4B;EAC5B,WAAW;AACb;;AAEA;EACE,UAAU;EACV,mBAAmB;EACnB,WAAW;EACX,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,cAAc;EACd,iBAAiB;EACjB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,wBAAwB;EACxB,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,eAAe;AACjB;AACA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,uBAAuB;EACzB;AACF;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,uBAAuB;EACzB;AACF;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,uBAAuB;EACzB;AACF","sourcesContent":[".message-detail {\n  width: 100%;\n  border: 1px solid #c2bfbe !important;\n  margin-bottom: 20px;\n}\n.message-details-info {\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 10px;\n}\n.message-details-info-header {\n  font-weight: 500;\n}\n\n.back-btn {\n  display: flex;\n  align-items: center;\n}\n.back-btn:hover {\n  display: flex;\n  align-items: center;\n  border-color: #009966 !important;\n  color: #009966 !important;\n}\n.message-item-meta-data {\n  flex: none !important;\n}\n.payapt-list-item {\n  display: flex;\n  justify-content: space-between;\n  width: 100%;\n}\n.ant-table-thead {\n  background-color: #e1dfde !important;\n}\n.test-data-container {\n  /* height: auto; */\n  /* border: 1px solid #F5F5F5; */\n  display: flex;\n  flex-direction: row;\n}\n/* messages-container. { */\n  /* align-items: center; */\n  /* justify-content: center; */\n  /* display: flex; */\n  /* height: 100%; */\n/* } */\n.test-case-menu-item {\n  font-family: \"Inter\";\n  font-style: normal;\n  font-weight: 600;\n  font-size: 14px;\n  line-height: 17px;\n  text-transform: capitalize;\n  color: var(--black-text);\n  margin-bottom: 12px;\n  padding-left: 24px;\n  height: 40px;\n  align-items: center;\n  width: auto;\n  align-items: center;\n  display: flex;\n  border-left: 4px solid var(--background-white);\n}\n.test-case-menu-item-active {\n  font-family: \"Inter\";\n  font-style: normal;\n  font-weight: 600;\n  font-size: 14px;\n  line-height: 17px;\n  text-transform: capitalize;\n  color: var(--black-text);\n  margin-bottom: 12px;\n  padding-left: 24px;\n  height: 40px;\n  width: auto;\n  align-items: center;\n  border-left: 4px solid var(--primary-color);\n  display: flex;\n  background-color: var(--menu-item-background);\n}\n.test-data-sidemenu {\n  width: 291px;\n  height: 400px;\n  border: 1px solid #f5f5f5;\n}\n.search-box {\n  /* width: 292px; */\n  height: 40px;\n  background: var(--background-white);\n  border: 1px solid var(--disabled-text-color);\n  border-radius: 0;\n  font-weight: 300;\n  font-size: 16px;\n  font-family: \"Inter\";\n  font-style: normal;\n}\n.search-icon {\n  color: var(--disabled-text-color);\n}\n.test-data-values-container {\n  /* width: 840px; */\n  /* width: auto !important; */\n  max-height: 60vh;\n  background: var(--background-white);\n  border: 1px solid #f5f5f5;\n  /* padding-top: 25px; */\n  /* padding-left: 9px; */\n  /* padding-bottom: 25px; */\n  /* padding-right: 13px; */\n  margin-right: 0px !important;\n}\n.test-data-value-row {\n  display: flex;\n  justify-content: space-between;\n  /* margin-bottom: 20px; */\n}\n.test-data-xpath-value {\n  width: 330px;\n  height: 30px;\n  background: var(--background-white);\n  border: 1px solid #c6cbd1;\n  border-radius: 5px;\n  margin-top: 5px;\n  margin-bottom: 5px;\n}\n.test-data-xpath {\n  display: flex;\n  flex-direction: column;\n}\n.xpath-label {\n  font-family: \"Inter\";\n  font-style: normal;\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 19px;\n\n  color: var(--text-color);\n  margin-bottom: 6px;\n}\n\n.test-data-footer-buttons {\n  /* margin-left: 5px !important; */\n  margin-top: 30px !important;\n  /* margin-bottom: 19px !important; */\n  padding-left: 14px;\n  display: flex;\n  gap: 5px;\n}\n.xpath-value-table-header {\n  /* width: 817px; */\n  height: 40px;\n  background: #f2f2f2;\n  border-radius: 5px 5px 0px 0px;\n}\n.table-col-header {\n  align-items: center;\n  font-family: \"Inter\";\n  font-style: normal;\n  font-weight: 600;\n  font-size: 18px;\n  line-height: 22px;\n  text-transform: capitalize;\n  color: var(--text-color);\n  padding-left: 14px;\n  display: flex;\n}\n.table-col-header1 {\n  align-items: center;\n  font-family: \"Inter\";\n  font-style: normal;\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 22px;\n  text-transform: capitalize;\n  color: var(--text-color);\n  padding-left: 14px;\n  display: flex;\n}\n.testcases-menu {\n  /* height: 460px; */\n  overflow: auto;\n  max-height: 55vh;\n  /* overflow-y: auto; */\n  display: grid;\n  position: relative;\n}\n.xpath-value-content {\n  overflow: auto;\n  padding: 10px;\n  display: grid;\n  position: relative;\n}\n.review-txt-header {\n  font-family: \"Inter\";\n  font-style: normal;\n  font-weight: 600;\n  font-size: 20px;\n  line-height: 24px;\n  text-transform: capitalize;\n  height: 24px;\n  color: #001a11;\n}\n.review-txt-content{\nheight: 17px;\nleft: 124px;\ntop: 173px;\n\nfont-family: 'Inter';\nfont-style: italic;\nfont-weight: 400;\nfont-size: 14px;\nline-height: 17px;\n/* identical to box height */\ncolor: #000000;\n}\n.xml-txt-label {\n  width: 75px;\n  height: 14.96px;\n  left: 123px;\n  top: 262px;\n  margin-bottom: 10px;\n\n  font-family: \"Inter\";\n  font-style: normal;\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 19px;\n  color: #001a11;\n}\n.xml-txt-area {\n  /* width: 90%;\n  height: 298px;\n  left: 123px;\n  top: 291px; */\n  background: #ffffff;\n  border: 1px solid #c6cbd1;\n  border-radius: 5px;\n  resize: none;\n  justify-content: flex-start;\n  display: flex;\n  width: 100%;\n  /* margin-bottom: 10px; */\n}\n.standalone-message-testcase-container {\n  display: flex;\n  flex-direction: row;\n  position: relative;\n  /* margin-left: 35px; */\n  /* margin-top: 22px; */\n  /* margin-right: 30px; */\n}\n\n.testcase-detail-container {\n  height: calc(90vh - 50px) !important;\n  overflow-y: auto;\n  background: #FFFFFF;\n  border-left: 1px solid #D4D4D4;\n}\n.testcase-detail-header {\n  height: 90px;\n  background: #F5F5F5;\n  border-left: 1px solid #D4D4D4;\n  align-items: flex-start;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  padding-left: 14px;\n  padding-right: 22px;\n  z-index: 100;\n}\n\n.Validation-detail-container {\n  height: 100vh !important;\n  overflow-y: auto;\n  background: #FFFFFF;\n  border-left: 1px solid #D4D4D4;\n}\n\n.Validation-detail-header {\n  background: #F5F5F5;\n  border-left: 1px solid #D4D4D4;\n  align-items: flex-start;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  padding-right: 22px;\n  z-index: 100;\n}\n.Validation{\n  display: flex;\n}\n\n.schemaValidationHeader{\n text-align: left;\n padding-left: 10px;\n padding-top: 15px;\n padding-bottom: 10px;\n font-size: 20px;\n font-weight: bold;\n}\n\n.schemaValidationSucces{\n  background-color: rgb(221, 248, 238);\n  text-align: left;\n  border-left: 6px solid green;\n  padding: 14px;\n }\n .schemaValidationError{\n  background-color: rgb(251, 237, 237);\n  text-align: left;\n  border-left: 6px solid rgb(221, 59, 59);\n  padding: 14px;\n }\n\n.testcase-detail-header > .header1 {\n  margin-left: 0 !important;\n  margin-top: 0;\n  margin-bottom: 6px;\n}\n.subtitle-buttons-container > .header2-italic {\n  margin: 0 !important;\n}\n.testcase-name {\n  font-family: 'Inter';\n  font-style: italic;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 20px;\n  color: var(--primary-color);\n}\n.testcase-details-row {\n  display: flex;\n  flex-direction: row;\n  margin-top: 15px;\n  margin-bottom: 15px;\n}\n.testcase-detail-item {\n  display: flex;\n  flex-direction: column;\n  width: 50%;\n}\n.testcase-detail-item-header {\n  font-family: 'Inter';\n  font-style: normal;\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 22px;\n  text-transform: capitalize;\n  color: var(--text-color);\n  text-align: left;\n  margin-bottom: 9px;\n}\n.testcase-detail-item-value {\n  font-family: 'Inter';\n  font-style: normal;\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 19px;\n  color: var(--black-text);\n  text-align: left;\n}\n.desc-title {\n  font-family: 'Inter';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 18px;\n  line-height: 22px;\n  text-transform: capitalize;\n  color: var(--text-color);\n  text-align: left;\n  display: flex;\n  margin-top: 14px;\n  margin-bottom: 9px\n}\n\n.desc-content {\n  font-family: 'Inter';\n  font-style: normal;\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 19px;\n  color: var(--black-text);\n  opacity: 0.8;\n  display: flex;\n  text-align: left;\n}\n.desc-subtitle {\n  margin-top: 20px;\n}\n.item-index-container {\n  display: flex;\n  flex-direction: row;\n}\n.panel-header {\n  font-family: 'Inter';\n  font-style: normal;\n  font-weight: 600;\n  font-size: 18px;\n  line-height: 22px;\n  text-transform: capitalize;\n  color: var(--text-color);\n  text-align: left;\n  background: #F2F2F2;\n\n  /* height: 48px; */\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n}\n.panel-content-container {\n  background-color: var(--background-white);\n  min-height: 30vh !important;\n  overflow-y: auto;\n}\n.panel-content {\n  padding-left: 14px;\n  padding-top: 20px;\n}\n.ant-collapse-content-box {\n  padding: 0 !important;\n}\n.subtitle-buttons-container {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  width: 100%;\n}\n.prev-next-buttons {\n  display: flex;\n  justify-content: space-between;\n  color: var(--text-color);\n}\n.testcase-details-container {\n  padding-left: 14px;\n  padding-right: 10px;\n  width: 100%;\n  overflow: auto;\n  height: '100%';\n  /* height: 80vh; */\n  /* position: sticky; */\n}\nbody {\n  overflow: auto;\n}\n.close-circle {\n  top: 8px;\n  right: 11px;\n  align-self: flex-end;\n  display: flex;\n}\n.nested_table > div> div>.ant-table {\n  margin-left: 0 !important;\n}\n.ant-table-expanded-row > .ant-table-cell {\n  padding-left: 0 !important;\n}\n.data-loader {\n  justify-self: center !important;\n  align-self: center !important;\n  display: flex !important;\n  color: var(--primary-color) !important;\n  width: 20px !important;\n  height: 20px !important;\n  position: absolute;\n}\n\n.cardTitle1{\n  background-color: rgb(209, 244, 250);\n  padding: 20px;\n  font-size: 20px;\n }\n\n .cardTitle2{\n  font-size: 20px;\n }\n\n .editor {\n  counter-reset: line;\n  border: 1px solid #daced1;\n  /* background-color: yellow; */\n}\n.source {\n  padding-left: 0px !important;\n  margin-right: 5px !important;\n  cursor:auto; \n}\n\n#text-area-with-line-number::-webkit-scrollbar {\n  width: 4px;\n  border-radius: 40px;\n  height: 4px;\n  cursor: pointer !important;\n}\n\n#text-area-with-line-number::-webkit-scrollbar-track {\n  background-color: #f2f2f2;\n  border-radius: 40px;\n}\n\n#text-area-with-line-number::-webkit-scrollbar-thumb {\n  border-radius: 10px;\n}\n\n.editor #codeArea {\n  outline: none;\n  padding-left: 60px !important;\n}\n\n.editor pre {\n  padding-left: 60px !important;\n}\n\n.editor .editorLineNumber {\n  position: absolute;\n  left: 0px;\n  color: #cccccc;\n  text-align: right;\n  width: 40px;\n  font-weight: 100;\n}\n\n.actionGroup{\n  display:flex;\n  flex-direction: row;\n}\n.iconGroup{\n  margin:0px 5px;\n  border:1px solid #C6CBD1;\n  border-radius:50%;\n}\n\n.span{\n  padding:5px 5px;\n}\n\n.cancelicon{\n  color: #D65442;\n  height: 10px;\n  width: 10px;\n}\n\n.checkicon{\n  color: #549E56;\n  height: 10px;\n  width: 10px;\n}\n\n.headerAction:hover{\n  cursor: pointer;\n}\n@media screen and ( min-height: 701px ) {\n  .content-save-btn {\n    height: 45vh !important;\n  }\n  .content-no-save-btn {\n    height: 45vh !important;\n  }\n}\n\n@media screen and ( max-height: 700px ) {\n  .content-save-btn {\n    height: 45vh !important;\n  }\n  .content-no-save-btn {\n    height: 45vh !important;\n  }\n}\n\n@media screen and ( max-height: 400px ) {\n  .content-save-btn {\n    height: 35vh !important;\n  }\n  .content-no-save-btn {\n    height: 35vh !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
